import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  document.title = t("privacyPolicy.pageTitle") + " | Zagraj Mi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card>
                <div className="bg-success-subtle position-relative">
                  <CardBody className="p-5">
                    <div className="text-center">
                      <h3>{t("privacyPolicy.header.title")}</h3>
                      <p className="text-muted mt-3 mb-0">
                        {t("privacyPolicy.header.subtitle")}
                      </p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsxlink="http://www.w3.org/1999/xlink"
                      xmlnssvgjs="http://svgjs.com/svgjs"
                      width="1440"
                      height="60"
                      preserveAspectRatio="none"
                      viewBox="0 0 1440 60"
                    >
                      <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                        <path
                          d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                          style={{ fill: "var(--vz-secondary-bg)" }}
                        ></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect
                            width="1440"
                            height="60"
                            fill="#FFFFFF"
                          ></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm icon-effect">
                        <div className="avatar-title bg-transparent text-success rounded-circle">
                          <i className="ri-check-double-fill fs-36"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h3>{t("privacyPolicy.dataAdmin.title")}</h3>
                      <p className="text-muted">
                        {t("privacyPolicy.dataAdmin.content")}
                      </p>

                      <h5>{t("privacyPolicy.whatData.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.whatData.p1")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.whatData.p2")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.whatData.p3")}
                      </p>

                      <h5>{t("privacyPolicy.purposes.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.purposes.p1")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.purposes.p2")}
                      </p>

                      <h5>{t("privacyPolicy.blikStripe.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.blikStripe.p1")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.blikStripe.p2")}{" "}
                        <a
                          href="https://stripe.com/pricing"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://stripe.com/pricing
                        </a>
                        . {t("privacyPolicy.blikStripe.p3")}
                      </p>

                      <h5>{t("privacyPolicy.recipients.title")}</h5>
                      <ul className="text-muted">
                        <li>{t("privacyPolicy.recipients.item1")}</li>
                        <li>{t("privacyPolicy.recipients.item2")}</li>
                        <li>{t("privacyPolicy.recipients.item3")}</li>
                      </ul>

                      <h5>{t("privacyPolicy.transferOutsideEEA.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.transferOutsideEEA.p1")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.transferOutsideEEA.p2")}{" "}
                        <a
                          href="https://stripe.com/privacy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://stripe.com/privacy
                        </a>.
                      </p>

                      <h5>{t("privacyPolicy.retention.title")}</h5>
                      <ul className="text-muted">
                        <li>{t("privacyPolicy.retention.item1")}</li>
                        <li>{t("privacyPolicy.retention.item2")}</li>
                        <li>{t("privacyPolicy.retention.item3")}</li>
                      </ul>

                      <h5>{t("privacyPolicy.hostData.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.hostData.p1")}
                      </p>
                      <ul className="text-muted">
                        <li>{t("privacyPolicy.hostData.item1")}</li>
                        <li>{t("privacyPolicy.hostData.item2")}</li>
                      </ul>
                      <p className="text-muted">
                        {t("privacyPolicy.hostData.p2")}
                      </p>

                      <h5>{t("privacyPolicy.userRights.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.userRights.content")}
                      </p>

                      <h5>{t("privacyPolicy.mandatory.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.mandatory.content")}
                      </p>

                      <h5>{t("privacyPolicy.automated.title")}</h5>
                      <p className="text-muted">{t("privacyPolicy.automated.content")}</p>
                    </div>
                  </div>

                  <div className="d-flex pt-4">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm icon-effect">
                        <div className="avatar-title bg-transparent text-success rounded-circle">
                          <i className="ri-check-double-fill fs-36"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h3>{t("privacyPolicy.cookies.title")}</h3>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.intro")}
                      </p>

                      <h5>{t("privacyPolicy.cookies.whatAre.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.whatAre.content")}
                      </p>

                      <h5>{t("privacyPolicy.cookies.whatWeUse.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.whatWeUse.p1")}
                      </p>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.whatWeUse.p2")}
                      </p>

                      <h5>{t("privacyPolicy.cookies.consent.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.consent.content")}
                      </p>

                      <h5>{t("privacyPolicy.cookies.manage.title")}</h5>
                      <p className="text-muted">
                        {t("privacyPolicy.cookies.manage.content")}
                      </p>
                    </div>
                  </div>

                  <div className="text-end">
                    <Link to="/" className="btn btn-danger">
                      {t("privacyPolicy.backToHome")}
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
